import { useKeycloak } from '@dsb-norge/vue-keycloak-js';
import createClient from 'openapi-fetch';
import type { InjectionKey } from 'vue';
import type { Client } from 'openapi-fetch';
import type { components, paths } from '@/lib/api/v1';

export type AppClient = Client<paths, `${string}/${string}`>;

export type LumarActivityWeekDto = components['schemas']['LumarActivityWeekDto'];

export type ContractorContactDto = components['schemas']['ContractorContactDto'];

export type SamplingContactDto = components['schemas']['SamplingContactDto'];

export const appClientKey = Symbol() as InjectionKey<AppClient>;

declare let window: Window & {
  VITE_API_BASE_URL: string;
};
export const config = {
  appApiBaseUrl: window['VITE_API_BASE_URL'] || import.meta.env.VITE_API_BASE_URL
};

export function useAppApi(): AppClient {
  const keycloak = useKeycloak();
  const client = createClient<paths>({ baseUrl: config.appApiBaseUrl });
  client.use({
    async onRequest({ request }) {
      request.headers.set('Authorization', `Bearer ${keycloak.token}`);
      return request;
    }
  });

  return client;
}
